import styles from "./searchBar.module.scss";

import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useRef, useState } from "react";
import Link from "next/link";
import { svgImages } from "@/lib/svgImages";

const SearchBar = ({ cats, isArticles }) => {
  const [expand, setExpand] = useState(false);
  const [show, setShow] = useState(false);
  const [searchVal, setsearchVal] = useState("");
  const [allData, setAllData] = useState(null);
  const [result, setResult] = useState([]);
  const [clikckLink, setClikckLink] = useState(false);
  const [loading, setLoading] = useState(false);
  const resultPopup = useRef();
  const [isClickingResult, setIsClickingResult] = useState(false);

  const handleExpand = () => {
    setExpand(true);
  };
  const handleInputChange = (e) => {
    setsearchVal(e.target.value);
    setShow(true);
  };
  const handleHidePopup = (e) => {
    // Don't hide popup if we're clicking on a result item
    if (isClickingResult) {
      return;
    }

    // Use setTimeout to allow click events to process first
    setTimeout(() => {
      if (!e.currentTarget.contains(e.relatedTarget)) {
        setShow(false);
      } else {
        setShow(true);
      }

      if (searchVal == "") {
        setExpand(false);
      }
    }, 100);
  };

  const handleResultClick = () => {
    setIsClickingResult(true);
    // Allow navigation to complete before hiding popup
    setTimeout(() => {
      setShow(false);
      setIsClickingResult(false);
    }, 200);
  };

  const handleResultMouseDown = (e) => {
    // Prevent the blur event from firing immediately in Safari
    e.preventDefault();
    setIsClickingResult(true);
  };

  useEffect(() => {
    (async () => {
      if (isArticles) {
        const data = await fetch(
          "https://cms.qrhub.io/wp-json/wp/v2/articles?per_page=100"
        ).then((res) => res.json());
        setAllData(data);
        setLoading(false);
      } else {
        const data = await fetch(
          "https://cms.qrhub.io/wp-json/wp/v2/help_center?per_page=100"
        ).then((res) => res.json());
        setAllData(data);
        setLoading(false);
      }
    })();
  }, []);

  if (isArticles) {
    useEffect(() => {
      if (allData != null && searchVal.length >= 2) {
        setResult([]);

        for (let index = 0; index < allData.length; index++) {
          const blogElem = allData[index];
          if (
            blogElem.title.rendered
              .toLowerCase()
              .indexOf(searchVal.toLowerCase()) !== -1 ||
            blogElem.content.rendered
              .toLowerCase()
              .indexOf(searchVal.toLowerCase()) !== -1
          ) {
            let elem = blogElem;

            for (let catIndex = 0; catIndex < cats.length; catIndex++) {
              const element = cats[catIndex];
              for (
                let allCatsIndex = 0;
                allCatsIndex < blogElem.articles_categories.length;
                allCatsIndex++
              ) {
                const curCatElem = blogElem.articles_categories[allCatsIndex];

                if (curCatElem == element.id) {
                  elem.cat = cats[catIndex];
                  break;
                }
              }
            }

            setResult((result) => [...result, elem]);
          }
        }
      }

      if (searchVal == "") {
        setResult([]);
      }
    }, [searchVal]);
  } else {
    useEffect(() => {
      if (allData != null && searchVal.length >= 2) {
        setResult([]);
        for (let index = 0; index < allData.length; index++) {
          const blogElem = allData[index];
          if (
            blogElem.title.rendered
              .toLowerCase()
              .indexOf(searchVal.toLowerCase()) !== -1 ||
            blogElem.content.rendered
              .toLowerCase()
              .indexOf(searchVal.toLowerCase()) !== -1
          ) {
            let elem = blogElem;
            for (let catIndex = 0; catIndex < cats.length; catIndex++) {
              const element = cats[catIndex];
              for (
                let allCatsIndex = 0;
                allCatsIndex < blogElem.help_center_categories.length;
                allCatsIndex++
              ) {
                const curCatElem =
                  blogElem.help_center_categories[allCatsIndex];
                if (curCatElem == element.id) {
                  elem.cat = cats[catIndex];
                  break;
                }
              }
            }
            setResult((result) => [...result, elem]);
          }
        }
      }
      if (searchVal == "") {
        setResult([]);
      }
    }, [searchVal]);
  }

  const highlight = (title) => {
    var newTitle = title
      .toLowerCase()
      .replaceAll(
        searchVal.toLowerCase(),
        " <span>" + searchVal.toLowerCase() + "</span>"
      );

    return newTitle;
  };

  return (
    <>
      <div className={`${styles["searchInnerContainer"]}`}>
        <Paper
          onBlur={(e) => handleHidePopup(e)}
          className={`${styles["searchField"]} ${
            expand ? styles["expanded"] : ""
          } `}
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: 150,
          }}
        >
          <InputBase
            onClick={handleExpand}
            onChange={handleInputChange}
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search..."
            value={expand ? searchVal : ""}
            inputProps={{ "aria-label": "Search..." }}
          />

          <IconButton type="button" sx={{ p: "10px" }} aria-label="search">
            <SearchIcon />
          </IconButton>
          <div
            ref={resultPopup}
            className={`${styles["searchResults"]} ${
              show ? "" : styles["hide"]
            }`}
          >
            {result.map((item) => {
              // Only render link if we have valid data
              if (!item || !item.slug) return null;

              const href = isArticles
                ? `/en/articles/${item.slug}`
                : item.cat?.slug
                ? `/en/help-center/${item.cat.slug}/${item.slug}`
                : null;

              // Don't render if href is invalid
              if (!href) return null;

              return (
                <Link
                  key={item.id}
                  className={`${styles["searchResultsItem"]}`}
                  href={href}
                  onClick={handleResultClick}
                  onMouseDown={handleResultMouseDown}
                >
                  {item.cat?.name}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: svgImages.chevronRight,
                    }}
                    className={styles.searchResultArrow}
                  />
                  <span
                    className={styles.searchResultTitle}
                    dangerouslySetInnerHTML={{
                      __html: highlight(item.title?.rendered || ""),
                    }}
                  />
                </Link>
              );
            })}
          </div>
        </Paper>
      </div>
    </>
  );
};

export default SearchBar;
